import { BaseContainerModel } from '../base-container.model';
import { bl_wms_entity_picker_label_RowInterface, bl_wms_entity_picker_label_RowClass } from '../../dbschema/index';

export class WmsEntityPickerLabelContainer extends BaseContainerModel {
    bl_wms_entity_picker_label: bl_wms_entity_picker_label_RowInterface = new bl_wms_entity_picker_label_RowClass();
}
